/**
 * Admin > Notifications view registry (PWA-2748). Kept free of React so the
 * route helper and redirect can be imported by App.tsx without pulling in the
 * lazily loaded page module.
 */
export const NOTIFICATION_VIEWS = [
  { key: "reports", title: "Reports", description: "Notifications sent and how many users they reached." },
  { key: "users", title: "Users", description: "Who can be reached, and on what." },
  { key: "new", title: "New notification", description: "Creating saves a draft. You schedule or send it from Drafts." },
  { key: "drafts", title: "Drafts", description: "Unsent notifications: open, schedule or send." },
  { key: "scheduled", title: "Scheduled", description: "Waiting to fire. Reschedule in place or cancel." },
  { key: "completed", title: "Completed", description: "Sent notifications with their final recipient outcomes." },
] as const;

export type NotificationView = (typeof NOTIFICATION_VIEWS)[number]["key"];

export const DEFAULT_NOTIFICATION_VIEW: NotificationView = "reports";

export const NOTIFICATIONS_BASE_PATH = "/admin/notifications";

export const notificationViewPath = (view: NotificationView): string => `${NOTIFICATIONS_BASE_PATH}/${view}`;

export function isNotificationView(value: string | undefined | null): value is NotificationView {
  return NOTIFICATION_VIEWS.some(view => view.key === value);
}
